import { Component } from "react";
import Input from "../../../blocks/Input";
import './payment-detail-modal.css'
import { useEffect } from "react";
import BaseModal from "../Base-modal";
import { JsonToTable } from "react-json-to-table";


const Content = ({closeModal, showModal, data}) => {
    console.log(data)
    return(
        <div className="detail">
            <JsonToTable json={data} />
        </div>
    )
}

class PaymentHistoryModal extends Component {
    state = {
        open: false
    }

    openModal = () => this.setState({open: true})
    closeModal = () => this.setState({open: false})


    render() {
        return (
            <BaseModal open={this.state.open} closeModal={this.closeModal}>
                <Content
                    {...this.props}
                    showModal={this.state.open}
                    closeModal={this.closeModal}
                />
            </BaseModal>
        )
    }
}

export default PaymentHistoryModal
